import type { DeliveryPartnersKeys, DeliveryPointItem, PvzTypes } from '@/entities/order/types/delivery'

export const getFilteredPoints = (
	points: DeliveryPointItem[] = [],
	activeType: DeliveryPartnersKeys,
	pvzType: PvzTypes
) => {
	if (!points?.length) return []
	let newPoints = points
	if (activeType) {
		newPoints = newPoints.filter(({ DELIVERY_PVZ_PARTNER }) => DELIVERY_PVZ_PARTNER === activeType)
	}
	if (pvzType === 'pvz') {
		newPoints = newPoints.filter(({ POSTAMAT }) => !POSTAMAT)
	}
	if (pvzType === `postomat`) {
		newPoints = newPoints.filter(({ POSTAMAT }) => !!POSTAMAT)
	}
	return newPoints
}
